// extracted by mini-css-extract-plugin
export default {"wrapper":"preloader_wrapper__LCB25","lds":"preloader_lds__djido","lds-facebook":"preloader_lds-facebook__maOF7"};